"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestUserInviteResend = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const userInviteResendMutation = (0, graphql_tag_1.default) `
mutation UserInviteResendMutation (
  $id: ID!
  $workspaceId: ID!
) {
  userInviteResend (
    id: $id
    workspace: $workspaceId
  ) {
    id
  }
}`;
const requestUserInviteResend = async (props) => {
    const { data, errors } = await (0, apollo_1.mutate)(userInviteResendMutation, {
        variables: props,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.userInviteResend;
};
exports.requestUserInviteResend = requestUserInviteResend;
